import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, TestWebhookSchema, WebhookResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.input<typeof WebhookResponseDataSchema>>

export function useTestWebhookMutation() {
  return useMutation({
    mutationFn: async (data: z.input<typeof TestWebhookSchema>) => {
      const response = await axios.post<Response>(`/integrations/webhook/test`, data)

      return response.data.data
    },
  })
}
